import { call, put, takeLatest, all } from 'redux-saga/effects';

import { getResourceBundle } from './api';

const { removeAPIError, addAPIError } = require('redux/apiErrors/sagas');

const {
  GET_LOCALIZATION_REQUESTING,
  GET_LOCALIZATION_SUCCESS,
  RESET_LOCALIZATION_ISFETCHING,
  GET_LOCALIZATION_REQUEST
} = require('./constants');

function* get() {
  try {
    yield call(removeAPIError);
    yield put({ type: GET_LOCALIZATION_REQUESTING });
    const response = yield call(getResourceBundle);

    yield put({ type: GET_LOCALIZATION_SUCCESS, payload: response.data });
  } catch (error) {
    yield put({ type: RESET_LOCALIZATION_ISFETCHING });
    yield call(addAPIError, error);
  }
}

function* watchList() {
  yield takeLatest(GET_LOCALIZATION_REQUEST, get);
}

export default function* resourceBundleSagas() {
  yield all([watchList()]);
}
